import { getSoundkitClipPath } from "@/lib/soundkit-clip-path";
import { cn } from "@/lib/utils";

type TrackArtworkProps = {
  src: string;
  alt: string;
  type?: string | null;
  tight?: boolean;
  className?: string;
  imgClassName?: string;
};

export default function TrackArtwork({
  src,
  alt,
  type,
  tight = false,
  className,
  imgClassName,
}: TrackArtworkProps) {
  if (type !== "SOUNDKIT") {
    return (
      <img
        src={src}
        alt={alt}
        className={cn("h-full w-full object-cover", className, imgClassName)}
      />
    );
  }

  return (
    <SoundkitArtwork src={src} alt={alt} className={className} tight={tight} />
  );
}

function SoundkitArtwork({
  src,
  alt,
  className,
  tight,
}: {
  src: string;
  alt: string;
  className?: string;
  tight?: boolean;
}) {
  const clipPath = getSoundkitClipPath(tight);

  return (
    <div
      className={cn("relative h-full w-full", className)}
      style={{
        clipPath,
        WebkitClipPath: clipPath,
        boxShadow: "0 10px 18px rgba(5,12,43,0.14)",
      }}
    >
      <img src={src} alt={alt} className="h-full w-full object-cover" />
      <div
        className="pointer-events-none absolute inset-0 border border-white/10"
        style={{ clipPath, WebkitClipPath: clipPath }}
      />
    </div>
  );
}
